import axios from "axios";

const API_BASE = "https://fliplyn-b-c.fly.dev";

export const createOwnerService = async (payload) => {
  try {
    const res = await axios.post(`${API_BASE}/owners/`, payload);
    return { success: true, data: res.data };
  } catch (err) {
    const msg =
      err?.response?.data?.detail ||
      "Failed to create owner. Please try again.";

    return {
      success: false,
      message: msg, // RETURN EXACT backend validation message
    };
  }
};
